import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { CalculatorForm } from '@/components/commission/calculator-form';

export function CommissionCalculatorPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/commissions" className="text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Commission Calculator</h1>
          <p className="text-muted-foreground">
            Run what-if scenarios to see your projected commission.
          </p>
        </div>
      </div>

      <CalculatorForm />
    </div>
  );
}
